module.exports = __webpack_public_path__ + "img/RO.5d9b0896.png";